import { request } from './http'

//登录
export function getIdex(id) {
    return request({
        method: 'get',
        url: '/api/api/index',
        data: {
            id
        },
    })
}

export function banner(type) {
    return request({
        method: 'post',
        url: '/api/api/banner',
        data: {
            type
        },
    })
}

export function solutionHeader(id) {
    return request({
        method: 'get',
        url: '/api/api/solutionHeader',
        data: {
            id
        },
    })
}

export function productHeader(id) {
    return request({
        method: 'get',
        url: '/api/api/productHeader',
        data: {
            id
        },
    })
}


export function solution(id) {
    return request({
        method: 'post',
        url: '/api/api/solution',
        data: {
            id
        },
    })
}


export function product(id) {
    return request({
        method: 'post',
        url: '/api/api/product',
        data: {
            id
        },
    })
}
export function product2(type) {
    return request({
        method: 'post',
        url: '/api/api/product',
        data: {
            type
        },
    })
}

export function aboutUs(id) {
    return request({
        method: 'get',
        url: '/api/api/aboutUs',
        data: {
            id
        },
    })
}

export function setting(id) {
    return request({
        method: 'get',
        url: '/api/api/setting',
        data: {
            id
        },
    })
}

export function newsCategory(id) {
    return request({
        method: 'get',
        url: '/api/api/newsCategory',
        data: {
            id
        },
    })
}

export function newsList(category_id, page, pageSize) {
    return request({
        method: 'post',
        url: '/api/api/newsLists',
        data: {
            category_id, page, pageSize
        },
    })
}

export function newsInfo(id,category_id) {
    return request({
        method: 'post',
        url: '/api/api/newsInfo',
        data: {
            id,
            category_id
        },
    })
}

export function submit(company_name,link_name,link_phone,need_desc) {
    return request({
        method: 'post',
        url: '/api/api/submit',
        data: {
            company_name,link_name,link_phone,need_desc
        },
    })
}




